//test
export const getCount = state => {
    return state.count
}



// WEBPACK FOOTER //
// ./src/store/getters.js